/* eslint-disable no-promise-executor-return */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
// import moment from 'moment'
import 'moment-timezone'
import {
  Form,
  Button,
  Modal,
  Container,
  Row,
  // Col,
  Spinner,
} from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons'
import apiServices from '../services/apiServices'

function Warn({ setting }) {
  const { size = 'md', show = false, handleClose } = setting

  return (
    <Modal
      style={{ zIndex: '1501' }}
      size={size}
      show={show !== false}
      onHide={() => handleClose(false)}
    >
      <Modal.Header
        className="AccFormModal justify-content-center text-center pt-4"
        closeButton
      >
        <Modal.Title>
          <h4>系統訊息</h4>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="d-flex AccformCard">
        <div className="assPermis w-100">
          <Form className="px-2 Form-card flex-grow-1">
            <Form.Group className="px-5 lh-md text-center text-wom">
              <FontAwesomeIcon
                icon={faCircleExclamation}
                style={{ height: '5rem' }}
                className="my-4"
              />
              <Form.Label className="w-100 fs-5 fw-bold text-center pb-4">
                確定要刪除
                {/* {show && target
                  ? target.setting.name ||
                    `專案${target.setting.id || target.project_id}`
                  : '專案'} */}
                嗎？
              </Form.Label>
            </Form.Group>
          </Form>
        </div>
      </Modal.Body>
      <Modal.Footer className="sendForm justify-content-center py-3">
        <Button variant="secondary" onClick={() => handleClose(false)}>
          取消
        </Button>
        <Button variant="wom" onClick={() => handleClose(show)}>
          確定
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

function Research() {
  // const getSheet = async () => {
  //   const res = await apiServices.data({
  //     path: 'sheet',
  //     method: 'get',
  //   })
  //   console.log(res)
  // }
  // useEffect(() => {
  //   getSheet()
  // }, [])

  // const getActivities = async (id) => {
  //   const res = await apiServices.data({
  //     path: `research/${id}/activities`,
  //     method: 'get',
  //     params: {
  //       since: '2025-02-01',
  //       until: '2025-02-10',
  //     },
  //   })
  //   console.log(res)
  // }

  // const getInsights = async (id) => {
  //   const res = await apiServices.data({
  //     path: `research/${id}/insights`,
  //     method: 'get',
  //     params: {
  //       since: '2025-02-01',
  //       until: '2025-02-10',
  //     },
  //   })
  //   console.log(res)
  // }

  const [accounts, setaccounts] = useState([])
  const getAccounts = async () => {
    const res = await apiServices.data({
      path: `research/accounts`,
      method: 'get',
    })
    setaccounts(res)
  }
  console.log(accounts)

  const init = {
    openai: [],
    activities: [],
    insights: [],
    // loading: true,
  }

  const [result, setresult] = useState(init)
  const { openai } = result
  const getOpenai = async (id) => {
    setresult({
      ...init,
      loading: true,
    })
    const res = await apiServices.data({
      path: `research/${id}/openai`,
      method: 'get',
      params: {
        since: '2024-02-01',
        until: '2024-03-04',
      },
    })
    setresult(res)
  }
  console.log(openai)

  const [selected, setselected] = useState('')
  useEffect(() => {
    // getActivities('act_1588128098558797')
    // getInsights('1588128098558797')
    if (false) getAccounts()
    if (selected) getOpenai(selected)
  }, [selected])

  // const handleDownloadData = async () => {
  //   const head = Object.keys(insights[0]).join()
  //   const content = insights
  //     .map((insight) =>
  //       Object.keys(insights[0])
  //         .map((key) => insight[key])
  //         .join()
  //     )
  //     .join('\n')
  //   const csvContent = `data:text/csv;charset=utf-8,${head}\n${content}`
  //   const encodedUri = encodeURI(csvContent)
  //   const link = document.createElement('a')
  //   link.setAttribute('href', encodedUri)
  //   link.setAttribute('download', 'insights.csv')
  //   document.body.appendChild(link) // Required for FF

  //   link.click()

  //   const head2 = Object.keys(activities[0]).join()
  //   const content2 = activities
  //     .map((activity) =>
  //       Object.keys(activities[0])
  //         .map((key) => activity[key])
  //         .join()
  //     )
  //     .join('\n')
  //   const csvContent2 = `data:text/csv;charset=utf-8,${head2}\n${content2}`
  //   const encodedUri2 = encodeURI(csvContent2)
  //   const link2 = document.createElement('a')
  //   link2.setAttribute('href', encodedUri2)
  //   link2.setAttribute('download', 'activity.csv')
  //   document.body.appendChild(link2) // Required for FF

  //   link2.click()
  // }

  const options = [
    {
      label: 'F1204_臺北市私立聯成電腦語文短期補習班(業二)',
      value: '1028639028309952',
    },
    {
      label: 'FW0169_日本羊醫_綺麗雅(業二)',
      value: '431826402281197',
    },
    {
      label: 'FW0471_嘉威_沛樂生活(業二)',
      value: '1050164582743208',
    },
  ]

  return (
    <Container
      className="bg-dots-light h-100 w-100 d-flex flex-column position-relative"
      style={{ overflowY: 'auto', overflowX: 'hidden' }}
      // onClick={() => setEditing('')}
    >
      <Row>
        <Form.Label>請選擇帳號</Form.Label>
        <Form.Select onChange={(e) => setselected(e.target.value)}>
          <option value="">請選擇</option>
          {options.map(({ label, value }) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
        </Form.Select>
      </Row>
      {result.loading ? (
        <div className="m-auto d-flex my-5">
          <Spinner
            className="m-auto"
            animation="border"
            variant="luca"
            size="sm"
            style={{
              animation: 'spinner-border 1.5s linear infinite',
            }}
          />
          <h5 className="text-luca my-auto ms-2">資料載入中...</h5>
        </div>
      ) : (
        <Row>
          <Form.Label>分析結果</Form.Label>
          {openai.map((ai, index) => (
            <React.Fragment key={index}>
              <Row key={index} className="my-3">
                <Form.Label>{ai.data.campaign_name}的分析結果</Form.Label>
              </Row>
              <Row key={index} className="my-3">
                <Form.Label>成效分析</Form.Label>
              </Row>
              {ai.research1 &&
                ai.research1.split('\n').map((t) => <Row>{t}</Row>)}
              <br />
              <Row key={index} className="my-3">
                <Form.Label>成效與活動分析</Form.Label>
              </Row>
              {ai.research2 &&
                ai.research2.split('\n').map((t) => <Row>{t}</Row>)}
            </React.Fragment>
          ))}
        </Row>
      )}
      {/* <Row>
        <Button onClick={handleDownloadData}>匯出資料</Button>
      </Row> */}
      {/* <Row>
        <Form.Label>活動紀錄</Form.Label>
        {activities[0] ? (
          <>
            <Row>
              {Object.keys(activities[0]).map((key) => (
                <Col key={key} xs={2}>
                  {key}
                </Col>
              ))}
            </Row>
            {activities.slice(0, 20).map((activitie, i) => (
              <Row key={i}>
                {Object.keys(activitie).map((key) => (
                  <Col key={key} xs={2}>
                    {activitie[key]}
                  </Col>
                ))}
              </Row>
            ))}
          </>
        ) : (
          <Row>尚未取得活動紀錄</Row>
        )}
      </Row>
      <Row>
        <Form.Label>成效</Form.Label>
        {insights[0] ? (
          <>
            <Row>
              {Object.keys(insights[0]).map((key) => (
                <Col key={key} xs={2}>
                  {key}
                </Col>
              ))}
            </Row>
            {insights.slice(0, 20).map((insight, i) => (
              <Row key={i}>
                {Object.keys(insight).map((key) =>
                  typeof insight[key] === 'string' ? (
                    <Col key={key} xs={2}>
                      {insight[key]}
                    </Col>
                  ) : (
                    <Col key={key} xs={2}>
                      {JSON.stringify(insight[key])}
                    </Col>
                  )
                )}
              </Row>
            ))}
          </>
        ) : (
          <Row>尚未取得成效</Row>
        )}
      </Row> */}
    </Container>
  )
}

Warn.propTypes = {
  setting: PropTypes.shape().isRequired,
}

export default Research
